import BaseCellHandler, {BaseCellHandlerProps} from './BaseCellHandler';
import BigNumberChartWrapper from '@/views/storyboard/charts/bignumber/BigNumberChartWrapper';
import {BigNumberChartData, ChartResponseData, MetricAggregationSingleNumberChartData} from 'entities/chartData';

class BigNumberCellHandler extends BaseCellHandler {
    constructor(props: BaseCellHandlerProps) {
        super(props);

        this.endpointUrl = props.chartQuery.output === 'terms_metric'
            ? window.URLS.performSearchQuery
            : window.URLS.searchQueryCountResource;
    }

    componentDidUpdate(prevProps: BaseCellHandlerProps, prevState: any) {
        const {chartQuery} = this.props;
        this.endpointUrl = chartQuery.output === 'terms_metric'
            ? window.URLS.performSearchQuery
            : window.URLS.searchQueryCountResource;

        super.componentDidUpdate(prevProps, prevState);
    }

    processData(data: ChartResponseData) {
        if (this.endpointUrl === window.URLS.searchQueryCountResource) {
            const bigNumberData = data as BigNumberChartData;
            if (bigNumberData && Object.keys(bigNumberData).length > 0) {
                if (bigNumberData.count === 0 && bigNumberData.comparableCount === 0) {
                    this.setState({
                        data: {} as ChartResponseData,
                        errorMsg: '',
                        loading: false,
                    });
                } else {
                    super.processData(bigNumberData);
                }
            } else {
                this.setState({
                    data: {} as ChartResponseData,
                    errorMsg: '',
                    loading: false,
                });
            }
        } else {
            const metricAggData = data as MetricAggregationSingleNumberChartData[];
            if (!metricAggData || metricAggData.length === 0 || !metricAggData[0]) {
                this.setState({
                    data: {} as ChartResponseData,
                    errorMsg: '',
                    loading: false,
                });
            } else {
                const result = metricAggData[0]?.Result || 0;
                const comparableDocCount = metricAggData[0]?.comparableDocCount || 0;
                if (result === 0 && comparableDocCount === 0) {
                    this.setState({
                        data: {} as ChartResponseData,
                        errorMsg: '',
                        loading: false,
                    });
                } else {
                    this.setState({
                        data: {
                            count: result,
                            comparableCount: comparableDocCount,
                        },
                        errorMsg: '',
                        loading: false,
                    });
                }
            }
        }
    }

    renderContent() {
        const {data, queryDuration} = this.state;
        const {scalingFactor} = this.props;
        const {comparablePeriod} = this.props;
        const {chartSettingsView, onPreviewFooterChange} = this.props;

        return (
            <BigNumberChartWrapper
                data={data as BigNumberChartData}
                scalingFactor={scalingFactor ?? ''}
                comparablePeriod={comparablePeriod}
                outputType={this.props.chartQuery.output}
                aggregationType={this.props.chartQuery.metric_aggregations_type}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
                onPreviewFooterChange={onPreviewFooterChange}
            />
        );
    }
}

export default BigNumberCellHandler;
